<template>
  <div class="card p-4">
    <h4>Parceiros do Curso</h4>

    <div class="col-12 mb-3">
      <form class="row" @submit.prevent="">
        <div class="col-12 col-md-6">
          <label>Nome</label>
          <input
            v-model="partner.name"
            :class="{
              'is-invalid': partner.errors.has('name')
            }"
            class="form-control form-control-sm"
          />
          <has-error :form="partner" field="name" />
        </div>

        <div class="col-12 col-md-6">
          <label>Link</label>
          <input
            v-model="partner.link"
            :class="{
              'is-invalid': partner.errors.has('link')
            }"
            class="form-control form-control-sm"
          />
          <has-error :form="partner" field="link" />
        </div>

        <div class="col-12 col-md-6">
          <label>Descrição</label>
          <textarea
            v-model="partner.description"
            :class="{
              'is-invalid': partner.errors.has('description')
            }"
            class="form-control form-control-sm"
          ></textarea>
          <has-error :form="partner" field="description" />
        </div>

        <div class="col-12 col-md-6 mt-3">
          <label for="partner-image">
            <div v-if="!this.partner.image" class="p-4 border rounded">Clique aqui para Carregar Image</div>
            <div v-else class="d-flex flex-column">
              <img class="border rounded" :src="this.partner.image" height="100" />
              <button class="btn btn-sm btn-danger" @click="removePartnerImage">Remover</button>
            </div>
          </label>

          <input type="file" class="d-none" id="partner-image" @change="updatePartnerImage"/>
        </div>

        <div class="col-12 col-md-2 text-right">
          <label>&nbsp;</label>
          <button class="btn btn-sm btn-success form-control" @click="save">Salvar</button>
        </div>
      </form>
    </div>

    <table class="table table-sm">
      <thead>
        <tr>
          <th>Image</th>
          <th>Nome</th>
          <th>Link</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item,index) in partners" :key="index">
          <td>
            <img class="border rounded" :src="item.image" height="70" />
          </td>
          <td>{{ item.name }}</td>
          <td>
            <a :href="item.link" target="_blank">{{ item.link }}</a></td>
          <td>
            <button
              class="btn btn-sm btn-danger"
              @click="del(item.id)"
            ><i class="fa fa-trash"></i></button>
            <button
              class="btn btn-sm btn-primary"
              @click="edit(item)"
            ><i class="fa fa-edit"></i></button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { Form } from 'vform'
import axios from 'axios'

export default {
  props: {
    course: {
      required: true
    }
  },
  watch: {
    course: {
      immediate: true,
      handler ( val, old ) {
        if ( val != undefined && val != old ) {
          this.load()
        }
      }
    }
  },
  data() {
    return {
      partners: [],
      partner: new Form({
        id: undefined,
        name: undefined,
        link: undefined,
        description: undefined,
        image: undefined,
        course_id: undefined
      })
    }
  },
  methods: {
    load: function () {
      axios.get(`/teacher/course/partner/${ this.course }`)
        .then(res => {
          console.log(res)
          this.partners = res.data;
        })
        .catch(err => {
          console.error(err);
        })
    },
    save: function () {
      this.partner.course_id = this.course;
      this.partner.post(`/teacher/course/partner`)
        .then(res => {
          this.partner.reset();
          this.load();
        })
        .catch(err => {
          console.error(err);
        })
    },
    del: function (id) {
      axios.delete(`/teacher/course/partner/${ this.course }/${ id }`)
        .then(res => {
          this.load();
        })
        .catch(err => {
          console.error(err);
        })
    },
    edit: function (partner) {
      this.partner.fill(partner);
    },
    updatePartnerImage: function ($event) {
      const reader = new FileReader();
      reader.readAsDataURL($event.target.files[0]);
      reader.onload = () => {
        this.partner.image = reader.result;
      };
      reader.onerror = error => console.error(error);
    },
    removePartnerImage: function () {
      this.partner.image = undefined;
    }
  }
}
</script>
